export default "__VITE_ASSET__CpYTZbIy__"